import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=1d860629&"
import script from "./TheFooter.vue?vue&type=script&defer=true&lang=js&"
export * from "./TheFooter.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports